import React from 'react';
import { Button, useTheme } from '@mui/material';
import PanelAlert from '../../../shared/components/PanelAlert';

/**
 * Inputs Browser Alert Component
 * Shows the current tree selection or instructions
 */
const InputsBrowserAlert = ({ 
  selectedNode, 
  filteredZipfileCount, 
  totalZipfileCount, 
  onClearFilter, 
  ...props 
}) => {
  const theme = useTheme();
  
  const getPrimaryMessage = () => {
    if (selectedNode) {
      // Build path from node data based on node type
      if (selectedNode.type === 'project') {
        return selectedNode.name;
      } else if (selectedNode.type === 'target') {
        return `${selectedNode.project} > ${selectedNode.name}`;
      } else if (selectedNode.type === 'batch') {
        // For batch, show the name without date prefix
        const batchName = selectedNode.name === '<none>' ? '<none>' : selectedNode.name;
        return `${selectedNode.project} > ${selectedNode.target} > ${batchName}`;
      }
    }
    return 'Use the tree below to browse and filter input archives';
  };

  const getSecondaryMessage = () => {
    if (selectedNode && filteredZipfileCount !== undefined) {
      return `${filteredZipfileCount} input archive${filteredZipfileCount !== 1 ? 's' : ''} in selection`;
    }
    return 'Navigate through Projects → Targets → Batches';
  };

  return (
    <PanelAlert
      severity={selectedNode ? "info" : "warning"}
      primaryMessage={getPrimaryMessage()}
      secondaryMessage={getSecondaryMessage()}
      action={
        selectedNode && (
          <Button 
            size="small" 
            sx={{ 
              fontSize: theme.typography.fontSize.xs, 
              p: 0, 
              minWidth: 'auto', 
              textTransform: 'none',
              alignSelf: 'center',
              mr: theme.spacing(1)
            }}
            onClick={onClearFilter}
          >
            Clear
          </Button>
        )
      }
      sx={{
        mx: theme.spacing(2),
        mt: theme.spacing(2),
        mb: theme.spacing(1.5)
      }}
      {...props}
    />
  );
};

export default InputsBrowserAlert;